import { render, staticRenderFns } from "./PracticeCreator.vue?vue&type=template&id=44c9f5bc&"
import script from "./PracticeCreator.vue?vue&type=script&lang=js&"
export * from "./PracticeCreator.vue?vue&type=script&lang=js&"
import style0 from "./PracticeCreator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PracticeCreator.vue"
export default component.exports